import React, { useState } from 'react';
import { api_url } from '../../Constants/web_services';
import { useSelector } from 'react-redux';
import { selectSignedIn, selectUserData } from '../../Redux/UserSlice';
import '../../Assets/css/no-arrow.css';

const Complains = ({ company: companyData }) => {
    const isSignedIn = useSelector(selectSignedIn);
    const userData = useSelector(selectUserData);
    const [name, setName] = useState(userData?.username || '');
    const [email, setEmail] = useState(userData?.email || '');
    const [contact, setContact] = useState(userData?.contact || "");
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(null);  // To track submission status (success/error)

    const handleSubmit = async (e) => {
        e.preventDefault();

        let formData;

        // Preparing form data based on user status
        if (isSignedIn) {
            formData = {
                name: userData?.username,
                contact: userData?.contact,
                email: userData?.email,
                user_id: userData?.id,
                message,
                company_id: companyData?.id,
            };
        } else {
            formData = {
                name,
                contact,
                email,
                message,
                company_id: companyData?.id,
            };
        }

        try {
            // Sending the POST request to the backend
            const response = await fetch(api_url + `/api/complain-and-suggestion`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Corrected header
                },
                mode: 'no-cors',
                body: JSON.stringify(formData),
            });

            console.log('Response:', response);

            // Resetting the form fields
            setName('');
            setContact('');
            setEmail('');
            setMessage('');

            // Showing success status
            setStatus('Your message has been successfully sent.');
        } catch (error) {
            console.error('Error:', error);

            // Showing error status
            setStatus('There was an error submitting your complaint. Please try again.');
        }
        setTimeout(() => {
            setStatus(null);
        }, 5000);
    };
    const isSubmitDisabled = !name || !email || !contact || !message;
    return (
        <div className="container">
            <div id="aon-provider-complaints" className="sf-provi-articles-box margin-b-50 sf-provi-fullBox">
                <h3 className="sf-provi-title s-18 fw-800 text-drk-primary">Suggestions and Complaints</h3>
                <div className="sf-divider-line" />
                <div className="sf-rating-outer row justify-content-around">
                    <div className="sf-provi-qform border-0 shadow rounded-3">
                        <form onSubmit={handleSubmit} className='sf-provi-qform border-0 shadow rounded-3'>
                            <div className="row">
                                {!isSignedIn ? (
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Name</label>
                                                <input
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    name="name"
                                                    type="text"
                                                    required
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Email</label>
                                                <input
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    name="email"
                                                    type="email"
                                                    required
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Phone</label>
                                                <input
                                                    value={contact}
                                                    onChange={(e) => setContact(e.target.value)}
                                                    name="contact"
                                                    type="number"
                                                    required
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Name</label>
                                                <input
                                                    value={userData?.username || userData?.name}
                                                    readOnly
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Email</label>
                                                <input
                                                    value={userData?.email || ''}
                                                    readOnly
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className='fw-700 text-drk-primary'>Phone</label>
                                                <input
                                                    value={contact}
                                                    onChange={(e) => setContact(e.target.value)} // Update the state
                                                    name="contact"
                                                    type="number"
                                                    required
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className='fw-700 text-drk-primary'>Message</label>
                                        <textarea
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            name="message"
                                            rows={3}
                                            className="form-control"

                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group text-center qout-submit-btn">

                                        <button disabled={isSubmitDisabled}
                                            className={`site-button ${isSubmitDisabled ? 'text-danger' : ''}`}>Send</button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        {/* Displaying Status Message */}
                        {status && (
                            <div className="alert alert-info mt-3">
                                {status}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Complains;
